import web3 from "web3/dist/web3.min.js";
import ABI from './LockABI.json'

const ethereum = window.ethereum;
const provider = new web3(ethereum);

const BTY_Contract = new provider.eth.Contract(
    ABI,
    "0x6a70D3A891bA8471A1cc18380B579B73D9503e21" // BTY合约地址
)

export default BTY_Contract;